export default __webpack_public_path__ + "static/media/partly_cloudy_day.a0b484c3.svg";